import { PosAttributes, PosAttributesMapValue } from 'common/types/posAttributes';

export const getPosAttributes = (
  posAttribute: PosAttributes,
  overrideRole?: string,
): PosAttributesMapValue => {
  switch (posAttribute) {
    case PosAttributes.password:
      return { accessLevel: 'password-required' };
    case PosAttributes.manager_override:
      return { accessLevel: 'manager-override', overrideRole };
    case PosAttributes.manager_override_with_backout:
      return { accessLevel: 'manager-backout', overrideRole };
    default:
      return { accessLevel: 'full' };
  }
};
